import dayjs from "dayjs";
import { trim } from "lodash";
import { STORE_TYPE } from "../../constants/store";
const CODE_SINGAPORE = "+65";
const CODE_SINGAPORE_OPEN = "+650";
const handlePhoneNumber = (phone: string) => {
  const prefixLocation = phone.includes(CODE_SINGAPORE);
  if (prefixLocation) {
    if (phone.includes(CODE_SINGAPORE_OPEN)) {
      return phone.replace(CODE_SINGAPORE_OPEN, "");
    } else {
      return phone.replace(CODE_SINGAPORE, "");
    }
  } else {
    return phone;
  }
};

export const getValuesFromStoreDetail = (store?: Store | null, address?: StoreAddress): CreateUpdateStoreValues => {
  const value = {
    status: store?.status ?? 0,
    name: trim(store?.name) ?? "",
    description: trim(store?.description) ?? "",
    logo: store?.logo ?? "",
    banners: store?.banners?.length ? store?.banners : [],
    is_restaurant: store?.is_restaurant ?? true,
    open_at: store?.open_at ? dayjs(store?.open_at, "HH:mm") : undefined,
    close_at: store?.close_at ? dayjs(store?.close_at, "HH:mm") : undefined,
    is_open_on_weekend: store?.is_open_on_weekend ?? false,
    weekend_open_at: store?.weekend_open_at ?? "",
    weekend_close_at: store?.weekend_close_at ?? "",
    service_supports: store?.service_supports || [],
    preOrderServices: store?.preOrderServices || [],
    address: trim(address?.address) || "",
    country: address?.country || undefined,
    district: address?.district || "",
    city_or_province: address?.city_or_province || "",
    postal_code: address?.postal_code || "",
    phone: address?.phone ? handlePhoneNumber(address?.phone) : "",
    coordinate: { lat: address?.coordinate?.lat.toString() || "", lng: address?.coordinate.lng?.toString() || "" },
    deliveryMinOrder: store?.deliveryMinOrder?.toString()
      ? Number(store?.deliveryMinOrder).toFixed(2)
      : Number(0).toFixed(2),
    pickupMinOrder: store?.pickupMinOrder?.toString() ? Number(store?.pickupMinOrder).toFixed(2) : Number(0).toFixed(2),
    location_type: address?.location_type || "",
    outletContactPerson: store?.outletContactPerson || undefined,
    halalCertified: store?.halalCertified || false,
    muslimOwned: store?.muslimOwned || false,

    isOpen24Hour: store?.openingHour?.isOpen24Hour || false,
    openingHoursMon: store?.openingHour?.openingHoursMon
      ? dayjs(store?.openingHour?.openingHoursMon, "HH:mm")
      : undefined,
    openingHoursTue: store?.openingHour?.openingHoursTue
      ? dayjs(store?.openingHour?.openingHoursTue, "HH:mm")
      : undefined,
    openingHoursWed: store?.openingHour?.openingHoursWed
      ? dayjs(store?.openingHour?.openingHoursWed, "HH:mm")
      : undefined,
    openingHoursThu: store?.openingHour?.openingHoursThu
      ? dayjs(store?.openingHour?.openingHoursThu, "HH:mm")
      : undefined,
    openingHoursFri: store?.openingHour?.openingHoursFri
      ? dayjs(store?.openingHour?.openingHoursFri, "HH:mm")
      : undefined,
    openingHoursSat: store?.openingHour?.openingHoursSat
      ? dayjs(store?.openingHour?.openingHoursSat, "HH:mm")
      : undefined,
    openingHoursSun: store?.openingHour?.openingHoursSun
      ? dayjs(store?.openingHour?.openingHoursSun, "HH:mm")
      : undefined,
    closingHoursMon: store?.openingHour?.closingHoursMon
      ? dayjs(store?.openingHour?.closingHoursMon, "HH:mm")
      : undefined,
    closingHoursTue: store?.openingHour?.closingHoursTue
      ? dayjs(store?.openingHour?.closingHoursTue, "HH:mm")
      : undefined,
    closingHoursWed: store?.openingHour?.closingHoursWed
      ? dayjs(store?.openingHour?.closingHoursWed, "HH:mm")
      : undefined,
    closingHoursThu: store?.openingHour?.closingHoursThu
      ? dayjs(store?.openingHour?.closingHoursThu, "HH:mm")
      : undefined,
    closingHoursFri: store?.openingHour?.closingHoursFri
      ? dayjs(store?.openingHour?.closingHoursFri, "HH:mm")
      : undefined,
    closingHoursSat: store?.openingHour?.closingHoursSat
      ? dayjs(store?.openingHour?.closingHoursSat, "HH:mm")
      : undefined,
    closingHoursSun: store?.openingHour?.closingHoursSun
      ? dayjs(store?.openingHour?.closingHoursSun, "HH:mm")
      : undefined,
    breakingStartHourMon: store?.openingHour?.breakingStartHourMon
      ? dayjs(store?.openingHour?.breakingStartHourMon, "HH:mm")
      : undefined,
    breakingEndHourMon: store?.openingHour?.breakingEndHourMon
      ? dayjs(store?.openingHour?.breakingEndHourMon, "HH:mm")
      : undefined,
    breakingStartHourTue: store?.openingHour?.breakingStartHourTue
      ? dayjs(store?.openingHour?.breakingStartHourTue, "HH:mm")
      : undefined,
    breakingEndHourTue: store?.openingHour?.breakingEndHourTue
      ? dayjs(store?.openingHour?.breakingEndHourTue, "HH:mm")
      : undefined,
    breakingStartHourWed: store?.openingHour?.breakingStartHourWed
      ? dayjs(store?.openingHour?.breakingStartHourWed, "HH:mm")
      : undefined,
    breakingEndHourWed: store?.openingHour?.breakingEndHourWed
      ? dayjs(store?.openingHour?.breakingEndHourWed, "HH:mm")
      : undefined,
    breakingStartHourThu: store?.openingHour?.breakingStartHourThu
      ? dayjs(store?.openingHour?.breakingStartHourThu, "HH:mm")
      : undefined,
    breakingEndHourThu: store?.openingHour?.breakingEndHourThu
      ? dayjs(store?.openingHour?.breakingEndHourThu, "HH:mm")
      : undefined,
    breakingStartHourFri: store?.openingHour?.breakingStartHourFri
      ? dayjs(store?.openingHour?.breakingStartHourFri, "HH:mm")
      : undefined,
    breakingEndHourFri: store?.openingHour?.breakingEndHourFri
      ? dayjs(store?.openingHour?.breakingEndHourFri, "HH:mm")
      : undefined,
    breakingStartHourSat: store?.openingHour?.breakingStartHourSat
      ? dayjs(store?.openingHour?.breakingStartHourSat, "HH:mm")
      : undefined,
    breakingEndHourSat: store?.openingHour?.breakingEndHourSat
      ? dayjs(store?.openingHour?.breakingEndHourSat, "HH:mm")
      : undefined,
    breakingStartHourSun: store?.openingHour?.breakingStartHourSun
      ? dayjs(store?.openingHour?.breakingStartHourSun, "HH:mm")
      : undefined,
    breakingEndHourSun: store?.openingHour?.breakingEndHourSun
      ? dayjs(store?.openingHour?.breakingEndHourSun, "HH:mm")
      : undefined,

    categoryLevel1Ids: store?.categoriesLevel1 ? store?.categoriesLevel1?.map((item: Category) => item.id) : [],
    categoryLevel2Ids: store?.categoriesLevel2 ? store?.categoriesLevel2?.map((item: Category) => item.id) : [],
    categoryLevel3Ids: store?.categoriesLevel3 ? store?.categoriesLevel3?.map((item: Category) => item.id) : [],
    isSpecialEvent: store?.isSpecialEvent || false,
    autoCloseOrderThreshold: store?.autoCloseOrderThreshold || null,
    autoOpenOrderThreshold: store?.autoOpenOrderThreshold || null,
    hasOwnDeliveryFleet: false,
    type: store?.type || STORE_TYPE.FOOD_DELIVERY,
  };
  return value;
};

export const getBodyFromStoreValues = (values: CreateUpdateStoreValues): CreateUpdateStoreBody => {
  return {
    name: values.name,
    description: values.description,
    logo: values.logo,
    banners: values.banners,
    is_restaurant: values.is_restaurant ?? true,
    open_at: values.open_at?.format("HH:mm") || "",
    close_at: values.close_at?.format("HH:mm") || "",
    is_open_on_weekend: values.is_open_on_weekend ?? false,
    weekend_open_at: values.weekend_open_at,
    weekend_close_at: values.weekend_close_at || "",
    service_supports: values.service_supports,
    preOrderServices: values.preOrderServices,
    status: 1,
    deliveryMinOrder: Number(values.deliveryMinOrder),
    pickupMinOrder: Number(values.pickupMinOrder),
    outletContactPerson: values?.outletContactPerson || undefined,
    halalCertified: values.halalCertified,
    muslimOwned: values.muslimOwned,
    openingHour: {
      isOpen24Hour: values.isOpen24Hour,
      openingHoursMon: values.openingHoursMon?.format("HH:mm:ss") || undefined,
      openingHoursTue: values.openingHoursTue?.format("HH:mm:ss") || undefined,
      openingHoursWed: values.openingHoursWed?.format("HH:mm:ss") || undefined,
      openingHoursThu: values.openingHoursThu?.format("HH:mm:ss") || undefined,
      openingHoursFri: values.openingHoursFri?.format("HH:mm:ss") || undefined,
      openingHoursSat: values.openingHoursSat?.format("HH:mm:ss") || undefined,
      openingHoursSun: values.openingHoursSun?.format("HH:mm:ss") || undefined,
      closingHoursMon: values.closingHoursMon?.format("HH:mm:ss") || undefined,
      closingHoursTue: values.closingHoursTue?.format("HH:mm:ss") || undefined,
      closingHoursWed: values.closingHoursWed?.format("HH:mm:ss") || undefined,
      closingHoursThu: values.closingHoursThu?.format("HH:mm:ss") || undefined,
      closingHoursFri: values.closingHoursFri?.format("HH:mm:ss") || undefined,
      closingHoursSat: values.closingHoursSat?.format("HH:mm:ss") || undefined,
      closingHoursSun: values.closingHoursSun?.format("HH:mm:ss") || undefined,
      breakingStartHourMon: values.breakingStartHourMon?.format("HH:mm:ss") || undefined,
      breakingEndHourMon: values.breakingEndHourMon?.format("HH:mm:ss") || undefined,
      breakingStartHourTue: values.breakingStartHourTue?.format("HH:mm:ss") || undefined,
      breakingEndHourTue: values.breakingEndHourTue?.format("HH:mm:ss") || undefined,
      breakingStartHourWed: values.breakingStartHourWed?.format("HH:mm:ss") || undefined,
      breakingEndHourWed: values.breakingEndHourWed?.format("HH:mm:ss") || undefined,
      breakingStartHourThu: values.breakingStartHourThu?.format("HH:mm:ss") || undefined,
      breakingEndHourThu: values.breakingEndHourThu?.format("HH:mm:ss") || undefined,
      breakingStartHourFri: values.breakingStartHourFri?.format("HH:mm:ss") || undefined,
      breakingEndHourFri: values.breakingEndHourFri?.format("HH:mm:ss") || undefined,
      breakingStartHourSat: values.breakingStartHourSat?.format("HH:mm:ss") || undefined,
      breakingEndHourSat: values.breakingEndHourSat?.format("HH:mm:ss") || undefined,
      breakingStartHourSun: values.breakingStartHourSun?.format("HH:mm:ss") || undefined,
      breakingEndHourSun: values.breakingEndHourSun?.format("HH:mm:ss") || undefined,
    },
    categoryLevel1Ids: values.categoryLevel1Ids ? values.categoryLevel1Ids : [],
    categoryLevel2Ids: values.categoryLevel2Ids ? values.categoryLevel2Ids : [],
    categoryLevel3Ids: values.categoryLevel3Ids ? values.categoryLevel3Ids : [],

    isSpecialEvent: false,
    type: values.type || STORE_TYPE.FOOD_DELIVERY,
    // autoCloseOrderThreshold: Number(values.autoCloseOrderThreshold),
    // autoOpenOrderThreshold: Number(values.autoOpenOrderThreshold),
  };
};

export const getAddressFromStoreValues = (values: CreateUpdateStoreValues): CreateUpdateStoreAddressBody => {
  return {
    address: values.address,
    service_supports: values.service_supports,
    description: "",
    coordinate: values.coordinate,
    country: values?.country || "",
    district: values?.district || "",
    city_or_province: values?.city_or_province || "",
    postal_code: values?.postal_code || "",
    phone: `${CODE_SINGAPORE}${values.phone[0] === "0" ? values.phone.replace("0", "") : values.phone}`,
    location_type: values.location_type,
  };
};
